import { IBiddingPagedRequest } from '../../../../model/apm/bidding/request/bidding-paged-request';
import { IBiddingResponse } from '../../../../model/apm/bidding/response/bidding-response';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';

export type BiddingSearchState = {
    parameters: IBiddingPagedRequest;
    searchTrigger: number;
    modalities: ILookupResponse[];
    managementUnits: ILookupResponse[];
    documentTypes: ILookupResponse[];
    // Anexos ficam separados do registro para não reiniciar o formulário a cada envio
    drawer: { open: boolean; bidding?: IBiddingResponse; files: IPortalDocumentResponse[] };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setLookups = 'setLookups',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
    setDrawerFiles = 'setDrawerFiles',
}

export const BiddingSearchReducer = (state: BiddingSearchState, action: any): BiddingSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setLookups:
            return { ...state, ...payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, bidding: payload, files: payload?.files || [] } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false, files: [] } };
        case ACTION_TYPES.setDrawerFiles:
            return { ...state, drawer: { ...state.drawer, files: payload } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
